import { app } from "../../../../Frame/App";
import { MarkupMeasureTreeModel, WidgetMeasureTreeModel } from "../../Widgets/WidgetMeasureTree";
import { DecimalDto } from "../../../../Model/DecimalDto";

export class MeasureTextProvider {

    public static fixedPlaceholders: { placeholder: string, action: () => string }[] = [
        {
            placeholder: "url-headline",
            action: () => {
                const serachParams = new URLSearchParams(window.location.search);
                const param = serachParams.get("headline");
                return param;
            }
        },
        {
            placeholder: "open-measure",
            action: () => {
                const serachParams = new URLSearchParams(window.location.search);
                const param = serachParams.get("parentId");
                return `Mso.PageWidgetCockpit.controller.openMeasure(${param})`;
            }
        },
        {
            placeholder: "parentId",
            action: () => {
                const urlParams = new URLSearchParams(window.location.search);
                const measureIdString = urlParams.get("parentId");
                let measureId: number = 0;

                if (measureIdString) {
                    measureId = Number(measureIdString);
                }

                if (isNaN(measureId)) {
                    measureId = 0;
                }

                return measureId.toString();
            }
        }
    ];

    public static getPlaceHolders(text: string): string[] {
        let placeholders: string[] = [];

        if (text && text.length > 0) {

            // old regex, in case safari supports it in the future: (?<=\[).+?(?=\])
            // Changed to regex without lookbehind, because of Safari on iOS.
            // \[.+?\]
            let regexp = new RegExp("\\[.+?\\]", "g");

            let matches = text.match(regexp);
            if (matches) {
                for (let match of matches) {
                    let cleanMatch = match.replace("[", "");
                    cleanMatch = cleanMatch.replace("]", "");

                    if (placeholders.indexOf(cleanMatch) < 0) {
                        placeholders.push(cleanMatch);
                    }
                }
            }
        }

        return placeholders;
    }

    public static replace(text: string, placeholder: string, value: string): string {
        if (text) {
            let replaceRegex = new RegExp("\\[(" + placeholder + ")\\]", "g");

            if (value && value.startsWith("{") && value.indexOf("decimalSeperator") > -1) {
                let dto = JSON.parse(value) as DecimalDto;
                value = app.formatDecimalNumber(dto.fieldValue, dto.decimalSeperator, dto.decimalPlaces);
            } else {
                value = MeasureTextProvider.convertLineBreaks(value);
            }

            text = text.replace(replaceRegex, value ?? '\u00A0');
        }
        return text;
    }

    public static convertLineBreaks(value: string): string {
        if (value) {
            value = value.replace(new RegExp("(?:\\r\\n|\\r|\\n)", "g"), '<br />');
        }
        return value;
    }

    public static replaceFixedPlaceholders(text: string): string {
        if (text) {
            for (let item of this.fixedPlaceholders) {
                text = this.replace(text, item.placeholder, item.action());
            }
        }
        return text;
    }

    /**
     * Replaces all placeholders with field unique Ids in the given text.
     */
    public static replaceMeasureText(text: string, measureId: number, callback: (text: string) => void = null, count: number = 0): string {
        if (!text) {
            return;
        }
        if (text && text.length > 0) {
            let placeholders = MeasureTextProvider.getPlaceHolders(text);

            if (placeholders.length > 0) {
                placeholders = placeholders.filter(p => !p.startsWith("localize:"));

                $.ajax({
                    url: app.resolveUrl(`~/api/measure/getMeasureValues/${measureId}`),
                    method: "POST",
                    contentType: "application/json",
                    data: JSON.stringify(placeholders),

                    async: callback ? true : false,
                    success: (response) => {
                        if (response) {
                            text = MeasureTextProvider.replaceConditionals(text, response);
                            text = MeasureTextProvider.replaceMeasureTextWithValues(text, placeholders, response, count);
                        }
                    },
                    error: (err) => {
                        console.log(err);
                    },
                    complete: () => {
                        if (callback) {
                            callback(text);
                        }
                    }
                });
            } else {
                if (callback) {
                    callback(text);
                }
            }
        }

        return text;
    }

    public static replaceConditionals(markup: string, values: { [name: string]: any }): string {
        let pattern: string = "\\bconditional\\b[(].*[)]";
        let regex = new RegExp(pattern, "g");
        let matches = markup.match(regex);

        if (matches && matches.length > 0) {
            matches.forEach(m => {
                // Format: conditional(<field>;<trueValue>;<falseValue>)
                // Reduce to list inside the parentheses
                let reducedMatch = m.substr(12);
                reducedMatch = reducedMatch.substr(0, reducedMatch.length - 1);

                var splitMatch = reducedMatch.split(";");
                if (splitMatch.length == 3) {
                    let field = splitMatch[0];
                    let trueValue = splitMatch[1];
                    let falseValue = splitMatch[2];

                    // Try to find raw boolean value in values object
                    let rawBoolean = values[field + "_Raw"];
                    if (rawBoolean == "true" || rawBoolean == "True") {
                        console.log("rawBoolean: " + rawBoolean);
                        markup = markup.replace(m, trueValue);
                    } else {
                        markup = markup.replace(m, falseValue);
                    }
                }
            });
        }

        return markup;
    }

    public static replaceMeasureTextWithValues(markup: string, placeholders: string[], values: { [name: string]: any }, count: number = 0) {
        for (let key of placeholders) {
            if (key == "@count") {
                markup = MeasureTextProvider.replace(markup, key, count.toString());
            } else
                markup = MeasureTextProvider.replace(markup, key, values[key] ? values[key] : "");
        }
        return markup;
    }



    /**
     * Replaces all placeholders that start with 'localize:' in the given text with the values from the passed jsonObject.
     * @param element
     * @param measureId
     */
    public static replaceLocalizedStrings(text: string, jsonData: any): string {
        if (!text || !jsonData) {
            return text;
        }

        if (text && text.length > 0) {
            let placeholders = MeasureTextProvider.getPlaceHolders(text);

            if (placeholders.length > 0) {
                placeholders = placeholders.filter(p => p.startsWith("localize:"));

                for (let placeholder of placeholders) {
                    var key = placeholder.substring(9);

                    if (jsonData[key] && jsonData[key][app.language]) {
                        text = MeasureTextProvider.replace(text, placeholder, jsonData[key][app.language]);
                    }
                }
            }
        }

        return text;
    }
}